import { FC } from "react";
import { Box, Button, ButtonProps, Text } from "@chakra-ui/react";

const GoogleWalletButton: FC<ButtonProps> = (props) => (
  <Button
    width="100%"
    height="55px"
    gap={3}
    bg="#1f1f1f"
    color="#fff"
    border="1px solid #747775"
    borderRadius="28px"
    _hover={{ bg: "#3c4043" }}
    _active={{ bg: "#3c4043" }}
    {...props}
    textTransform="none"
  >
    <svg width="36" height="30" viewBox="21 12.5 36 30" aria-hidden="true">
      <path d="M57 23.791H21V18.1455C21 15.0809 23.6422 12.5001 26.7798 12.5001H51.2202C54.3578 12.5001 57 15.0809 57 18.1455V23.791Z" fill="#34A853"/>
      <path d="M57 29H21V23C21 19.7429 23.6422 17 26.7798 17H51.2202C54.3578 17 57 19.7429 57 23V29Z" fill="#FBBC04"/>
      <path d="M57 34H21V28C21 24.7429 23.6422 22 26.7798 22H51.2202C54.3578 22 57 24.7429 57 28V34Z" fill="#EA4335"/>
      <path d="M21 25.2409L43.8493 30.4025C46.4795 31.0477 49.4384 30.4025 51.5753 28.7895L57 24.9183V37.0157C57 40.0804 54.3699 42.4999 51.2466 42.4999H26.7534C23.6301 42.4999 21 40.0804 21 37.0157V25.2409Z" fill="#4285F4"/>
    </svg>
    <Box textAlign="left" lineHeight="1.15">
      <Text fontSize="12px" fontWeight="400">Добавить в</Text>
      <Text fontSize="18px" fontWeight="500">Google Кошелёк</Text>
    </Box>
  </Button>
)

export default GoogleWalletButton
